/**
 * 商品接口
 * 
 * @author 张子超
 * @since 2018-04-04
 * 
 * store.loginedUser.easyUser
 */
import common from './common'
import store from './store'




var ApiList = {};

//API 接口



/**
 * 获取分类列表
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.getCategoryList = function (okCb, failCb) {
    var p = {}
    common.ApiWithCache('/customer/api/category/list.json', p, okCb, failCb)
}


/**
 * 获取规格列表
 * @param {*} categoryId
 * @param {*} tagGroupId
 * @param {*} tagId 
 * @param {*} title 
 * @param {*} orderType 
 * @param {*} direction 
 * @param {*} filterByMyPoint
 * @param {*} lastId
 * @param {*} limit
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.getSkuList = function (categoryId, tagGroupId, tagId, title, orderType, direction, filterByMyPoint, lastId, limit, okCb, failCb) {
    var p = {
        categoryId,
        tagGroupId,
        tagId,
        title, 
        orderType,
        direction,
        filterByMyPoint,
        lastId,
        limit
    }
    if (store.loginedUser.easyUser) {
        common.Api('/customer/api/easySku/list.json', p, okCb, failCb)
    } else {
        common.Api('/customer/api/sku/list.json', p, okCb, failCb)
    }
}

/**
 * 获取商品详情
 * @param {*} skuId
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.getProduct = function (skuId, okCb, failCb) {
    var p = {
        skuId
    }
    if (store.loginedUser.easyUser) {
        common.Api('/customer/api/easyProduct/detail.json', p, okCb, failCb)
    } else {
        common.Api('/customer/api/product/get.json', p, okCb, failCb)
    }
}

/**
 * 获取商品列表
 * @param {*} skuIds
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.getProductList = function (skuIds, okCb, failCb) {
    var p = {
        skuIds: skuIds.join(',')
    }
    if (store.loginedUser.easyUser) {
        common.ApiWithCache('/customer/api/easyProduct/list.json', p, okCb, failCb)
    } else {
        common.ApiWithCache('/customer/api/product/getList.json', p, okCb, failCb)
    }
}

/**
 * 
 * @param {*} areaLevel 
 * areaLevel: integer - 等级
    1: PROVINCE
    2: CITY
    3: DISTRICT
    4: TOWN
 * @param {*} code 
    code: integer? - 父级CODE
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.getAddress = function (areaLevel, code,okCb, failCb) {
    var p = {
        areaLevel,
        code
    }
    common.ApiWithCache('/customer/api/userJingdongAddress/area.json', p, okCb, failCb)
}

ApiList.saveAddress = function (provinceCode, cityCode, districtCode, townCode, area, detail, receiver, telephone,isDefault,okCb, failCb) {
    var p = {
        provinceCode,
        cityCode, 
        districtCode, 
        townCode, 
        area, 
        detail, 
        receiver, 
		telephone,
		isDefault
    }
    common.Api('/customer/api/userJingdongAddress/add.json', p, okCb, failCb)
}

ApiList.takeVmall = function (machineSn, pricePoint, skuId,okCb, failCb) {

    var p = {
        pricePoint,
        skuId
    };

    if (machineSn) {
        p['machineSn'] = machineSn
    }

    common.Api('/customer/api/order/takeVmall.json', p, okCb, failCb)
}


/**
 * 易小付充值
/customer/api/yixiaofu/charge.json

RequireLogin: true

参数
    gainId: integer - 卡获取ID,必填
    phoneAddressId: integer - 用户手机id
返回
    cardno: string - 卡号
    name: string - 卡券名称
    phone: string - 手机号
    platform: string - 卡密平台
    rechargeTime: string - 提卡时间
 * @param {*} gainId 
 * @param {*} phoneAddressId 
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.yixiaofuCharge = function (gainId, phoneAddressId, okCb, failCb) {

    var p = {
        gainId, phoneAddressId
    };

    common.Api('/customer/api/yixiaofu/charge.json', p, okCb, failCb)
}

/**
 * 查询易小付充值
/customer/api/yixiaofu/queryCharge.json

RequireLogin: true

参数
    gainId: integer - 卡获取ID,必填
返回
    vcardChargeYixiaofuVo: object? -
        cardno: string - 卡号
        chargeStatus: integer - 充值状态 0-未充值，1-充值成功，2-充值失败
            0: NOCHARGE
            1: SUCCESS
            2: FAIL
        chargeTime: string - 充值时间
        createTime: string - 创建时间
        id: integer - ID
 * @param {*} gainId 
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.yixiaofuQueryCharge = function (gainId, okCb, failCb) {

    var p = {
        gainId
    };

    common.Api('/customer/api/yixiaofu/queryCharge.json', p, okCb, failCb)
}


export default ApiList;


// WEBPACK FOOTER //
// ./src/api/product-api.js